import { type CommonProperties, datadogRum } from "@datadog/browser-rum";

import envService from "./env.service";
import type { GetMeResponseDto } from "./spz-api/model";

export const initDatadogRum = () => {
  // Initialisation de Datadog RUM
  datadogRum.init({
    applicationId: envService.env.datadog.applicationId,
    clientToken: envService.env.datadog.clientToken,
    site: envService.env.datadog.site,
    service: envService.env.datadog.service,
    env: envService.env.datadog.envName,
    allowedTracingUrls: [
      envService.env.api.url,
      // track all supervizor urls
      /https:\/\/.*\.supervizor\.com/,
    ],
    // app version could be retrieve from package.json (optional)
    version: "1.0.0",
    // track  session (clics, scroll, etc.)
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    enablePrivacyForActionName: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  // Record replay sessions
  datadogRum.startSessionReplayRecording();
};

// Types for Datadog context
export type DatadogUserContext = CommonProperties["usr"] & {
  isSupervizorUser: boolean;
  isAdmin: boolean;
};

export interface DatadogGlobalContext {
  orgId: string;
}

const isSupervizorUser = (email: string) => {
  return email.endsWith("@supervizor.com");
};

/**
 * Configures user and organization context in Datadog RUM
 *
 * @param me - User data from useGetMe()
 */
export const setAuthenticatedUserContext = (me: GetMeResponseDto) => {
  // User context: userId, isSupervizorUser, isAdmin
  const userContext: DatadogUserContext = {
    id: String(me.id),
    isSupervizorUser: isSupervizorUser(me.email),
    isAdmin: me.isAdmin,
  };
  datadogRum.setUser(userContext);

  // Organization context: orgId
  const globalContext: DatadogGlobalContext = {
    orgId: String(me.organization.id),
  };
  datadogRum.setGlobalContext(globalContext);
};
